import React from 'react';
import {
  DropdownItemProps,
  Pagination as SemanticPagination,
} from 'semantic-ui-react';
import { PaginationProps } from 'semantic-ui-react/dist/commonjs/addons/Pagination/Pagination';
import POSIcon from '../POSIcon';
import DropdownSelectRowsPerPage from '../DropdownSelectRowsPerPage';

interface Props {
  onPageChange: (
    event: React.MouseEvent<HTMLAnchorElement>,
    data: PaginationProps
  ) => void;
  onPageSizeChange?: (pageSize: number) => void;
  pageCount: number;
  pageIndex: number;
  totalRows?: number;
  showRowsPerPageSelection?: boolean;
  dropDownOptions?: DropdownItemProps[];
}

export const Pagination = (props: Props) => {
  const disableFirstAndPrevious = props.pageIndex === 0;
  const disableLastAndNext = props.pageIndex === props.pageCount - 1;

  const stylingObject = {
    div: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
  };

  return (
    <div style={stylingObject.div}>
      {props.showRowsPerPageSelection && (
        <DropdownSelectRowsPerPage
          handleOnChange={props.onPageSizeChange}
          pageIndex={props.pageIndex}
          totalRows={props.totalRows || 0}
          dropDownOptions={props.dropDownOptions}
        />
      )}
      <SemanticPagination
        totalPages={props.pageCount}
        activePage={props.pageIndex + 1}
        ellipsisItem={'...'}
        lastItem={<></>}
        firstItem={<></>}
        prevItem={{
          disabled: disableFirstAndPrevious,
          content: <POSIcon icon="arrow-left" />,
          icon: true,
        }}
        nextItem={{
          disabled: disableLastAndNext,
          content: <POSIcon icon="arrow-right" />,
          icon: true,
        }}
        onPageChange={props.onPageChange}
      />
    </div>
  );
};
